import { render } from "./InviteLinkPage.vue?vue&type=template&id=c252574a&scoped=true"
import script from "./InviteLinkPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteLinkPage.vue?vue&type=script&setup=true&lang=js"

import "./InviteLinkPage.vue?vue&type=style&index=0&id=c252574a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c252574a"],['__file',"src/components/modals/InviteLinkPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c252574a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c252574a', __exports__)) {
    api.reload('c252574a', __exports__)
  }
  
  module.hot.accept("./InviteLinkPage.vue?vue&type=template&id=c252574a&scoped=true", () => {
    api.rerender('c252574a', render)
  })

}


export default __exports__